// https://optimistic.etherscan.io/address/0x48A9FE90bce5EEd790f3F4Ce192d1C0B351fd4Ca
export const CROSS_CHAIN_CONTROLLER = '0x48A9FE90bce5EEd790f3F4Ce192d1C0B351fd4Ca';

// IPayloadsControllerCore https://optimistic.etherscan.io/address/0x0E1a3Af1f9cC76A62eD31eDedca291E63632e7c4
export const PAYLOADS_CONTROLLER = '0x0E1a3Af1f9cC76A62eD31eDedca291E63632e7c4';

// https://optimistic.etherscan.io/address/0xE3B770Dc4ae3f8bECaB3Ed12dE692c741603e16A
export const PC_DATA_HELPER = '0xE3B770Dc4ae3f8bECaB3Ed12dE692c741603e16A';

// https://optimistic.etherscan.io/address/0x6c5264C380C7022e54f585c4E354ffb6f221a03b
export const GRANULAR_GUARDIAN = '0x6c5264C380C7022e54f585c4E354ffb6f221a03b';

// https://optimistic.etherscan.io/address/0x360c0a69Ed2912351227a0b745f890CB2eBDbcFe
export const GOVERNANCE_GUARDIAN = '0x360c0a69Ed2912351227a0b745f890CB2eBDbcFe';

// https://optimistic.etherscan.io/address/0x746c675dAB49Bcd5BB9Dc85161f2d7Eb435009bf
export const EXECUTOR_LVL_1 = '0x746c675dAB49Bcd5BB9Dc85161f2d7Eb435009bf';

export const CHAIN_ID = 10;
